import { render, staticRenderFns } from "./SearchLogs.vue?vue&type=template&id=23ae5650&scoped=true"
import script from "./SearchLogs.vue?vue&type=script&lang=js"
export * from "./SearchLogs.vue?vue&type=script&lang=js"
import style0 from "./SearchLogs.vue?vue&type=style&index=0&id=23ae5650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae5650",
  null
  
)

export default component.exports